import moment from 'moment'
import { EmploymentTypeT } from 'domain/constants'
import { FormValuesJobForManager } from 'types/job/jobTypesManager'

interface Rate {
  rateFrom?: number
  rateTo?: number
  currency?: string
}

const toRateNumber = (value: number | string | null | undefined): number | undefined => {
  if (value === null || value === undefined || value === '') return undefined

  const parsedValue = Number(value)
  return Number.isNaN(parsedValue) ? undefined : parsedValue
}

export const transformJob = (
  {
    rateFrom,
    rateTo,
    salaryFrom,
    salaryTo,
    salaryCurrency,
    rateCurrency,
    ...values
  }: FormValuesJobForManager,
  employmentTypeConst: EmploymentTypeT
) => {
  const {
    country,
    city,
    travelPercent,
    travel,
    relocation,
    startAt,
    endAt,
    employeeType,
    client
  } = values
  const { w2Type, ...rest } = values
  const data =
    employeeType && employeeType[employmentTypeConst.get('w2')]
      ? { ...values, w2Checked: true }
      : rest
  const recruiters =
    data.recruiters && data.recruiters.length > 0
      ? data.recruiters.filter(item => item && item.value).map(item => item && item.value)
      : []
  const hourly: Rate = {}
  const salary: Rate = {}
  const hourlyRateFrom = toRateNumber(rateFrom)
  const hourlyRateTo = toRateNumber(rateTo)
  const salaryRateFrom = toRateNumber(salaryFrom)
  const salaryRateTo = toRateNumber(salaryTo)
  const hasHourlyRateFrom = hourlyRateFrom !== undefined
  const hasHourlyRateTo = hourlyRateTo !== undefined
  const hasSalaryRateFrom = salaryRateFrom !== undefined
  const hasSalaryRateTo = salaryRateTo !== undefined

  if (hasHourlyRateFrom) hourly.rateFrom = hourlyRateFrom
  if (hasHourlyRateTo) hourly.rateTo = hourlyRateTo
  if (hasSalaryRateFrom) salary.rateFrom = salaryRateFrom
  if (hasSalaryRateTo) salary.rateTo = salaryRateTo

  if (hasHourlyRateFrom || hasHourlyRateTo) {
    hourly.currency = rateCurrency && rateCurrency.label
  }
  if (hasSalaryRateFrom || hasSalaryRateTo) {
    salary.currency = salaryCurrency && salaryCurrency.label
  }

  return {
    ...data,
    startAt: moment(startAt).startOf('day'),
    endAt: moment(endAt).endOf('day'),
    countryId: 0, // TODO: remove after countryId
    cityId: city ? city.value : undefined,
    clientId: client ? client.value : '',
    employeeType:
      employeeType && Object.keys(employeeType).filter((key: string) => employeeType[key]),
    hourly: Object.keys(hourly).length > 0 ? hourly : undefined,
    salary: Object.keys(salary).length > 0 ? salary : undefined,
    salaryCurrency: salaryCurrency ? salaryCurrency.label : 0,
    rateCurrency: rateCurrency ? rateCurrency.label : 0,
    travel: travel === 'yes' ? true : travel === 'no' ? false : null,
    relocation: relocation === 'true' ? true : relocation === 'false' ? false : null,
    travelPercent: travelPercent ? travelPercent.value : null,
    backgroundCheck: true,
    clearanceType: Object.keys(data.clearanceType).filter(
      (key: string) => !!data.clearanceType[key] && key !== 'none'
    ),
    employmentType: Object.keys(data.employmentType).filter(
      (key: string) => !!data.employmentType[key] && key !== 'employmentTypeDesc'
    ),
    employmentTypeDesc: data.employmentType ? data.employmentType.employmentTypeDesc : null,
    citizenship: Object.keys(data.citizenship).filter(
      (key: string) => data.citizenship[key] && key !== 'citizenshipDesc'
    ),
    citizenshipDesc: data.citizenship ? data.citizenship.citizenshipDesc : null,
    recruiters
  }
}
